module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 154
// module chunks = 0